import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { FiltroListaIntegracaoGtr } from '../../filtro/filtro-lista-integracao-gtr';
import { IntegracaoGtrService } from '../../service/integracao-gtr.service';
import { LogIntegracaoGtr, getLogIntegracaoGtrDefault } from '../../interface/integracao-gtr';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-integracao-gtr-lista',
  templateUrl: './integracao-gtr-lista.component.html',
  styleUrls: ['./integracao-gtr-lista.component.css']
})
export class IntegracaoGtrListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroListaIntegracaoGtr;
  logVisualiza: LogIntegracaoGtr = getLogIntegracaoGtrDefault();
  itemIntegrar: LogIntegracaoGtr = getLogIntegracaoGtrDefault();

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private integracaoGtrService: IntegracaoGtrService,
    private poStorageService: PoStorageService,
    private poNotificationService: PoNotificationService,
  ) {

    this.tabelaPrincipalFiltro = new FiltroListaIntegracaoGtr(this.poStorageService);

  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('integrarGtrModal', { static: true }) integrarGtrModal!: PoModalComponent;
  @ViewChild('logModal', { static: true }) logModal!: PoModalComponent;
  @ViewChild('formIntegrar', { static: true }) formIntegrar!: NgForm;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.integracaoGtrService.lista(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return { ...item, favorite: ['integrar', 'log'] };
      });
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CIDRETORNO'       , label: 'Id Ret'           , width: '5%'},
    {property: 'DD3EMISSAO'       , label: 'Dt Emissão'       , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CDHPROCESSAMENTO' , label: 'DtHr Proces.'     , width: '13%'},
    {property: 'CD3COD'           , label: 'Cód. Produto'     , width: '10%'},
    {property: 'CB1DESC'          , label: 'Produto'          , width: '20%'},
    {property: 'CD3OP'            , label: 'OP'               , width: '10%'},
    {property: 'CD3LOTESOL'       , label: 'Lote'             , width: '5%'},
    {property: 'CMOVIMENTO'       , label: 'Tp Movimento'     , width: '7%'},
    {property: 'CINTEGRADO', label: 'Integrado'         , width: '10%', type: 'label',
      labels: [
        { value: '0', color: 'color-05',  label: 'Não Integrado'    },
        { value: '1', color: 'color-01',  label: 'Integrado' },
      ]
    },
    {property: 'favorite'  , label: '...'             , width: '10%' , type: 'icon',
      icons: [
        {
          action: this.openIntegrarGtr.bind(this),
          icon: 'po-icon-edit',
          tooltip: 'Integrar',
          value: 'integrar',
        },
        {
          action: this.visualizarLog.bind(this),
          icon: 'po-icon-eye',
          tooltip: 'Log',
          value: 'log',
        },
      ]
    }
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Integração GTR', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  openIntegrarGtr(row: LogIntegracaoGtr): void {
    this.itemIntegrar = row;
    this.integrarGtrModal.open();
  }

  public readonly integrarActionModal: PoModalAction = {
    action: () => {
      if (this.formIntegrar.valid) {
        this.integrarGtrModal.close();
        this.integrar();
      } else {
        this.poNotificationService.warning({message: "Por favor, preencha a descrição do retorno (máximo de 200 caracteres).", duration: 5000});
      }
    },
    label: 'Integrar',
  };

  integrar(): void {
    this.integracaoGtrService.postIntegracaoGtr(this.itemIntegrar).subscribe((ret) => {
      this.poNotificationService.success({message:"Registro atualizado com sucesso!", duration: 5000});
      this.tabelaPrincipalLoad();
    });
  }

  visualizarLog(row: LogIntegracaoGtr): void {
    this.logVisualiza = row;
    this.logModal.open();
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
